import { CSSProperties } from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Divider as MuiDivider, SxProps } from '@mui/material';

interface StyleProps {
  color?: CSSProperties['color'];
  orientation?: 'vertical' | 'horizontal';
  sx?: SxProps<Theme>;
}

const useStyles = makeStyles((theme: Theme) => ({
  divider: {
    background: ({ color }: StyleProps) => color || theme.customPalette.silver,
    margin: theme.spacing(2),
    height: ({ orientation }: StyleProps) => (orientation === 'horizontal' ? '1px !important' : undefined)
  }
}));

interface Props {
  color?: CSSProperties['color'];
  orientation?: 'vertical' | 'horizontal';
  flexItem?: boolean;
  sx?: SxProps<Theme>;
}

const Divider = ({ color, orientation, flexItem, sx }: Props) => {
  const classes = useStyles({ color, orientation });

  return <MuiDivider className={classes.divider} orientation={orientation} flexItem={flexItem} sx={sx} />;
};

export default Divider;
